<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 order-2 order-lg-1">
            <div
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <div class="row">
                <div class="col-md-7 order-md-1 order-2 my-auto">
                  <h1>Welcome to Traitstack!</h1>
                  <p>
                    Traitstack started with the mission to open up the
                    undertanding of human potential and quirkyness through
                    simple and modern assessments! We hope you find the quizes
                    interesting and the reports insightful. Enjoy your stay!
                  </p>
                  <router-link
                    v-if="!$hasCompletedPersonality()"
                    to="/test/personality"
                    class="btn btn-medium btn-primary"
                    >Discover your personality</router-link
                  >
                  <router-link
                    v-if="
                      !$hasCompletedPathways() && $hasCompletedPersonality()
                    "
                    to="/test/pathways"
                    class="btn btn-medium btn-primary"
                    >Discover your career pathways</router-link
                  >
                  <a
                    v-if="$hasCompletedPathways() && $hasCompletedPersonality()"
                    href="https://forms.gle/G2BNiMHne83q8geu7"
                    class="btn btn-tertiary btn-md"
                    target="_blank"
                    >Give feedback on your experience</a
                  >
                </div>
                <div class="col-md-5 order-md-2 order-1">
                  <v-lazy-image src="/static/img/intro_combo.svg" alt />
                </div>
              </div>
            </div>
            <div
              class="panel content-panel text-sm-center service-panel pad-medium service-panel-large"
              v-bind:class="{ glow: !$hasCompletedPersonality() }"
            >
              <div class="row">
                <div class="col-md-4 text-center">
                  <img
                    src="/static/img/icon_personality.svg"
                    class="svg-image"
                    alt
                  />
                </div>
                <div class="col-md-7 my-auto">
                  <h3 class="blue">Insights</h3>
                  <h4>Uncover who you are</h4>
                  <p>
                    Each one of us is unique and interesting. What does your
                    personality look like? Find out your strenghts and
                    orientations in this 10 minute test.
                  </p>
                  <router-link
                    v-if="$hasCompletedPersonality()"
                    to="/results/personality"
                    class="btn btn-medium btn-primary"
                    >View results</router-link
                  >
                  <router-link
                    v-if="!$hasCompletedPersonality()"
                    to="/test/personality"
                    class="btn btn-medium btn-primary"
                    >Start assessment</router-link
                  >
                </div>
              </div>
            </div>
            <div
              class="panel content-panel text-sm-center service-panel pad-medium service-panel-large"
              v-bind:class="{
                glow: $hasCompletedPersonality() && !$hasCompletedPathways(),
              }"
            >
              <div class="row">
                <div class="col-md-4 text-center">
                  <img
                    src="/static/img/icon_workforce.svg"
                    class="svg-image"
                    alt
                  />
                </div>
                <div class="col-md-7 my-auto">
                  <h3 class="blue">Pathways</h3>
                  <h4>Find your career fit</h4>
                  <p>
                    Our interests and motivations inform the types of tasks we
                    prefer to spend time on. Find your perfect career fit, the
                    training requirements, average salary, tasks, and demand.
                  </p>
                  <router-link
                    v-if="$hasCompletedPathways()"
                    to="/results/pathways"
                    class="btn btn-medium btn-primary"
                    >View results</router-link
                  >
                  <router-link
                    v-if="!$hasCompletedPathways()"
                    to="/test/pathways"
                    class="btn btn-medium btn-primary"
                    >Start assessment</router-link
                  >
                </div>
              </div>
            </div>
            <div
              class="panel content-panel text-sm-center service-panel oh pad-medium service-panel-large"
            >
              <div class="row">
                <div class="col-md-4 text-center">
                  <img
                    src="/static/img/icon_performance.svg"
                    class="svg-image"
                    alt
                  />
                </div>
                <div class="col-md-7 my-auto">
                  <h3 class="blue">Potential</h3>
                  <h4>Test your limit</h4>
                  <p>
                    Our brains are incredibly powerful machines. Like machines,
                    they are able to handle a limited amount of information.
                    Find out what kind of information you work best with.
                  </p>
                  <button
                    type="button"
                    class="btn btn-medium btn-primary"
                    v-on:click="performanceOpen = !performanceOpen"
                  >
                    Learn more
                  </button>
                  <div
                    class="info-container"
                    v-bind:class="{ active: performanceOpen }"
                  >
                    <button
                      class="close-info"
                      v-on:click="performanceOpen = !performanceOpen"
                    >
                      <font-awesome-icon icon="times" />
                    </button>
                    <h3>Coming soon!</h3>
                    <p>Subscribe and we'll let you know when it's available!</p>
                    <MailChimp />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 order-1 order-lg-2">
            <div v-if="getUser" class="panel content-panel service-panel">
              <div class="person-card pad-medium">
                <div class="row no-gutters">
                  <div class="col-3">
                    <UserAvatar />
                  </div>
                  <div class="col-9">
                    <div class="person-info">
                      <h4>
                        {{ getUserData.firstName }} {{ getUserData.lastName }}
                      </h4>
                      <span
                        v-if="getUser.emailVerified"
                        class="verified-tag verified"
                        >Verified</span
                      >
                      <span v-else class="verified-tag"
                        >Pending Verification</span
                      >
                      <div class="icon-actions">
                        <button
                          class="icon-link"
                          title="Friends"
                          v-tippy
                          @click="$toggleFriendsModal()"
                        >
                          <font-awesome-icon icon="users" />
                        </button>
                        <router-link
                          to="/profile"
                          class="icon-link"
                          title="Profile"
                          v-tippy
                        >
                          <font-awesome-icon icon="cog" />
                        </router-link>
                        <button
                          @click="$signOut()"
                          class="icon-link"
                          title="Sign out"
                          v-tippy
                        >
                          <font-awesome-icon icon="sign-out-alt" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="getting-started-card pad-medium">
                <h4>Get started</h4>
                <div class="todo">
                  <router-link
                    v-if="$hasCompletedPersonality()"
                    to="/results/personality"
                    class="item completed"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Insights</h5>
                      <span>Complete assessment</span>
                    </div>
                  </router-link>

                  <router-link
                    v-if="!$hasCompletedPersonality()"
                    to="/test/personality"
                    class="item"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Insights</h5>
                      <span>Complete assessment</span>
                    </div>
                  </router-link>

                  <router-link
                    v-if="$hasCompletedPathways()"
                    to="/results/pathways"
                    class="item completed"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Pathways</h5>
                      <span>Complete assessment</span>
                    </div>
                  </router-link>

                  <router-link
                    v-if="!$hasCompletedPathways()"
                    to="/test/pathways"
                    class="item"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Pathways</h5>
                      <span>Complete assessment</span>
                    </div>
                  </router-link>

                  <router-link
                    to="/profile"
                    class="item"
                    @click="$toggleFriendsModal()"
                    :class="{ completed: completedProfile }"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Complete profile</h5>
                      <span>Fill out details</span>
                    </div>
                  </router-link>

                  <a
                    @click="$toggleFriendsModal()"
                    class="item"
                    :class="{ completed: this.getFriends.length > 0 }"
                  >
                    <div class="item-status">
                      <span class="ring">
                        <font-awesome-icon icon="check" />
                      </span>
                    </div>
                    <div class="item-info">
                      <h5>Invite friends</h5>
                      <span>Get the party started!</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="panel content-panel blue-panel light pad-medium hidden-sm"
            >
              <h3>Invite your friends</h3>
              <p>
                Invite your friends and compare your reports.
              </p>
              <button
                @click="$toggleFriendsModal()"
                type="button"
                class="btn btn-medium btn-primary"
              >
                <span>Invite friends</span>
              </button>
            </div>
            <div
              class="panel content-panel grad-panel light pad-medium hidden-sm"
            >
              <h3>Feedback</h3>
              <p>
                Have a minute to spare to give feedback on your experience?
                Please use the
                <a href="https://forms.gle/G2BNiMHne83q8geu7" target="_blank"
                  >feedback form</a
                >.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { mapState } from "vuex";
import SVGInjector from "svg-injector";
import UserAvatar from "@/components/UserAvatar.vue";
import MailChimp from "@/components/MailChimp.vue";

export default {
  name: "dashboard",
  components: { UserAvatar, MailChimp },
  data() {
    return {
      performanceOpen: false,
      workforceOpen: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    ...mapState(["userPrivateData"]),
    getUserPrivateData() {
      return this.userPrivateData ? this.userPrivateData : "";
    },
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
    completedProfile() {
      if (
        this.getUserData.firstName &&
        this.getUserData.lastName &&
        this.getUserData.age &&
        this.getUserData.country &&
        this.getUserData.industry &&
        this.getUserData.subIndustry
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    var mySVGsToInject = document.querySelectorAll(".svg-image");
    SVGInjector(mySVGsToInject);
  },
  methods: {
    signOut: function() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            console.log("Signed Out");
            this.$router.replace("sign-in");
          },
          (error) => {
            console.error("Sign Out Error", error);
          }
        );
    },
  },
};
</script>
